<template>
  <div class="race-event-card compact">
    <div class="bg" :style="backgroundStyle">
      <div class="sash" v-if="!raceEvent.isPublic">
        Private
      </div>
      <header @click="clickedRace(null)">
        <figure class="race-logo">
          <img :src="raceLogoImage" :alt="raceEvent.name + ' Logo'" />
          <img :src="raceLogoImage" :alt="raceEvent.name + ' Logo'" class="backdrop"/>
        </figure>
        
        <hgroup>
          <h1>{{ raceEvent.name }}</h1>
          <span class="year">{{ yearDisplay }}</span>
        </hgroup>
        <h2 v-if="firstRace">
          {{ $fmt.dateWithTimezone(firstRace.startTime, this.raceEvent?.timezoneOffset) }}
        </h2>
      </header>

      <div v-if="timezoneName" class="tz-info">
        This event time is shown in <em>local time at the race start</em><br />
        (location is {{ timezoneDifferenceDisplay }} than browser local time)
      </div>
      
      <template v-if="true">
        <ul class="race-list" :class="{group: races.length > 1}">
          <li v-for="r in races" :key="r.id" :style="`--race-color: ${r.color}`" @click="clickedRace(r)">
            <span class="rname" :title="r.name">{{ r.name }}</span>
            <span class="rtime">{{ $fmt.dateWithTimezone(r.startTime, this.timezoneName) }}</span>
            <span v-if="timezoneDisplay" class="tz">({{ timezoneDisplay }})</span>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<style lang="scss">
.race-event-card {
  border-radius: 16px;
  margin: 1em 6px;
  box-shadow: 0 3px 14px rgba(0,0,0,0.4);
  --logo-width: 96px;
  --logo-height: max(100px, calc(64px + 8px + 8px));
  --bg: transparent;
  --overlay-bg: linear-gradient(to bottom, rgba(255,255,255,0.2) 0%, rgba(0,0,0,0.0) 10%, rgba(0,0,0,0.4) 100%);
  --left-pad: calc(var(--logo-width) + 8px + 8px);
  position: relative;
  overflow: hidden;
  color: var(--text-dim1-color);
  
  .bg {
    border-radius: 16px;
    
    min-height: var(--logo-height);
    position: relative;
    padding: 1em;
    cursor: pointer;
//    background: var(--bg), var(--overlay-bg);
    background:var(--bg);
    transition: background-color 0.4s ease;
    &:hover { background-color: rgb(255 255 255 / 0.01);}
  }
    
  &:hover {
    h1 {
      text-shadow: 0 0 10px rgba(255,255,255,0.5);
      color: var(--text-color);
    }
  }
  
  &:active {
    h1 {
      transition: all 0.1s ease;
      text-shadow: 0 2px 4px rgba(255,255,255,0.5);
      color: rgba(0,0,0,0.7);
    }
  }

  canvas {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  
  .sash {
    color: white;
    font-weight: bold;
    text-align: center;
    border: 1px solid white;
    background: #520303;
    background: linear-gradient(135deg, #520303, #C43E3E);
    position: absolute;
    --a: 50px;
    --x: 2rem;
    --y: calc( var(--a) / 2);
    top: 0;
    right: 0rem;
    width: hypot(var(--a), var(--a));
    transform: translate(var(--x), var(--y)) rotate(45deg);
    padding: 0 2rem;
    z-index: 3;
  }
  
  h1 {
    font-size: 44px;
    line-height: 44px;
    text-align: left;
    margin: 0;
    padding-top: 8px;
    padding-left: 0 - var(--left-pad);
    font-weight: 900;
    text-shadow: 0 -1px rgba(0,0,0,0.5);
    color: var(--text-dim1-color);
    mix-blend-mode: hard-light;

    transition: all 0.5s ease;
  }
  
  h2 {
    font-size: 22px;
    font-weight: 100;
    line-height: 32px;
    color: var(--text-dim1-color);
    text-align: left;
    margin: 0;
    text-shadow: 0 1px rgba(255,255,255,0.5);
  }
  
  .race-logo {
    position: absolute;
    left: -10px;
    top: 0;
    width: calc(var(--logo-width) *1.5);
    height: calc(var(--logo-width) *1.5);
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
//    background: rgba(255 255 255 / 0.7);
    border: 2px solid rgb(255 255 255 / 0.5);
    border-radius: 50%;
    img {
      max-width: calc(var(--logo-width) *1.75);
      max-height: calc(var(--logo-width) *1.75);
      filter: drop-shadow(0px 5px 20px rgba(255,255,255,0.3));
      position: relative;
      z-index: 2;
      left: 55%;
      &.backdrop {
        transform: scale(10);
        filter: blur(7px);
        z-index: -1;
      }
    }
  }
  
  header { 
    position: relative; 
    padding-left: var(--left-pad);
  }
  
  h1,h2 {
    position: relative;
    z-index: 10;
    background: rgb(var(--neg-components) / 0.2);
    padding-left: 1rem;
    margin-left: -1rem;
  }
  
  .tz-info {
    padding-left: calc(var(--logo-width) + 1rem);
  }
  
  .race-list {
    background: rgb(var(--neg-components) / 0.2);
    margin-top: 0.5em;
    padding-left: calc(var(--logo-width) + 1rem);
    li { padding: 0 0.5em; transition: all 0.4s ease; display: flex; align-items: center; white-space: nowrap; }
    li:nth-child(2n+1) { background: rgba(0,0,0,0.1);}
    li:hover { text-shadow: 0 0 5px rgba(255,255,255,1); }
    
    // Race colors unless there's only one race, in which case the
    // entire card will be the correct color
    &.group li {
      border-left: 4px solid var(--race-color);
    }
    
    span { display: inline-block; }
    .rname { width: calc(var(--logo-width) + 5.75rem); text-overflow: ellipsis; overflow: hidden;}
    .tz { 
      margin-left: 1ex; 
      padding: 0.25em 0.5rem;
      background: rgba(0,0,0,0.1);
      border-radius: 4px;
      font-size: 0.75em;
      font-weight: bold;
      font-variant: small-caps;
      box-shadow: inset 0 0 5px rgba(0,0,0,0.4);
      white-space: nowrap;
    }
  }
}

.race-event-card.compact {
  background: var(--popover-abgcolor);
  border: 1px solid var(--text-dim3-color);
  --logo-width: 32px;
  h1 { font-size: 1.5rem; line-height: 1rem;}
  h2 { font-size: 1.0rem; }
  figure { }
}

@media screen and (max-width: 375px) {
  .race-event-card {
    --logo-width: 64px;
  }
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  /* phones in portrait mode */
  .race-event-card {
    header {
      h2 {
        font-size: 1.15rem;
      }
    }
    .race-list {
      li {
        line-height: 2rem;
        .rtime { flex-basis: 73%;}
      }
    }
  }
}

</style>

<script>
  // import Trianglify from 'trianglify'
  // import workletURL from "@/workers/triangle-painter.js?worker&url"
  import { tintColor }  from '@/utils.js'
  // import { formatTimestamp }  from '@z/lib/format'

  export default {
    props: {
      raceEvent: {
        type: Object,
        required: true,
      }
    },
    
    emits: ['clickedRace'],
    
    data() {
      return {
        backgroundType: undefined // 'paint' or 'webkit'
      }
    },
    
    computed: {
      races() { 
        return this.raceEvent.races.sort((a,b) => b.distance - a.distance)
        // return this.$store.getters.entity('races', this.raceEvent.races).sort((a,b) => b.distance - a.distance );
      },

      racesByStartTime() { 
        return [...this.races].sort((a,b) => {
          if (!a || !a.startTime) return -Infinity;
          if (!b || !b.startTime) return Infinity;
          return a.startTime - b.startTime; 
        });
      },

      firstRace() {
        const races = this.racesByStartTime || [];
        for (let i=0; i<races.length; i++) {
          if (races[i].startTime) return races[i];
        }

        return races[0];
      },
      
      yearDisplay() {
        const races = this.racesByStartTime;
        let yearStart = null;
        let yearEnd = null;
        for (let i=0; i<races.length; i++) {
          const y = races[i].startTime?.getFullYear();
          if (!yearStart || yearStart > y) yearStart = y;
          if (!yearEnd   || yearEnd < y)   yearEnd   = y;
        }

        if (!yearStart && yearEnd) return yearEnd;
        if (!yearEnd || yearEnd === yearStart) return yearStart;
        return `${yearStart}-${yearEnd}`
      },
      
      raceLogoImage() {
        return this.raceEvent.imageUrl;
      },
      
      backgroundStyle() {
        // return this.backgroundType == 'paint' ?
        //   `--bg: paint(triangles); --rc: ${this.raceColors.join(' ')}` :
        //   `--bg: -webkit-canvas(${this.raceEvent.slug})`
      },
      
      // Name that will be accepted by a tzinfo database
      timezoneName() {
        const offset = this.raceEvent.timezoneOffset;
        return offset == this.localTimezoneOffset ? undefined : `Etc/GMT+${Math.abs(offset)}`;
      },
      
      // Name that will be accepted by a participant or spectator
      timezoneDisplay() {
        const offset = this.raceEvent.timezoneOffset;
        if (offset == this.localTimezoneOffset) return undefined;
        
        return `UTC${offset}`;
      },
      
      localTimezoneOffset() {
        return new Date().getTimezoneOffset() / 60 * -1;
      },
      
      timezoneDifferenceDisplay() {
        const diff = this.localTimezoneOffset - this.raceEvent.timezoneOffset;
        const absDiff = Math.abs(diff);

        return `${absDiff} ${this.$fmt.pluralize(absDiff, 'hour')} ${diff > 0 ? 'earlier' : 'later'}`
      },
      
      raceColors() {
        let colors = (this.races.length) ? [this.races[0].color || '#1E8991'] : ['#1E8991'];
        
        if (colors.length < 1)
          colors.push('#eee');
        
        for (let i=1; i<this.races.length && i<2; i++)
          colors.push(this.races[i++].color);
        
        if (colors.length < 2) {
          // darker version of the race color
          let c = colors[0];
          colors.push(tintColor(c, 72));
        }
        
        return colors;
      }
    },
    
    mounted() {
      // card background
/*
      if (!document.getCSSCanvasContext) {
        // console.log("Houdini!", workletURL);
        // console.log("import meta: ", x);
        this.backgroundType = 'paint';
        try {
          if (!window.cssPaintWorklets) window.cssPaintWorklets = [];
          if (!window.cssPaintWorklets.includes('triangle-painter')) {
            console.log(`adding triangle-painter module: (${workletURL})`);
            window.cssPaintWorklets.push('triangle-painter');
            CSS.paintWorklet.addModule(workletURL);
          }
        }
        catch (e) {
          // fallback
          this.$el.style.backgroundColor = 'var(--med-bgcolor)';
        }
      }
      else {
        this.backgroundType = 'webkit';
        if (this.paintBackground()) {
          document.body.addEventListener('resize', () => this.paintBackground() );
          document.body.addEventListener('orientationchange', () => this.paintBackground() );
        }
        else {
          // fallback
          this.$el.style.backgroundColor = 'var(--med-bgcolor)';
        }
      }
*/
    },
    
    methods: {
      paintBackground() {
/*
        try {
          let colors = this.raceColors;
        
          window.t = Trianglify;
        
          requestAnimationFrame(() => {
            console.debug(`paint background (scaling height ${this.$el.clientHeight}) ver2`, colors);
            var pattern = Trianglify({
              width: document.body.clientWidth,
              height: this.$el.clientHeight,
              cellSize: 30,
              xColors: colors,
              variance: 0.8,

              // y_colors: ['red', ...colors]
              // x_colors: 'RdYlGn',
            });
        
            const ctx = document.getCSSCanvasContext("2d", this.raceEvent.slug, document.body.clientWidth, this.$el.clientHeight);
            pattern.toCanvasCtx(ctx);
          })

          return true
        } catch (e) {
          console.error("Could not paint background:", e);
          return false;
        }
*/
      },
      
      clickedRace(r) {
        console.debug("card: clicked race", r);
        this.$emit('clickedRace', this.raceEvent, r);
      },
    }
  }
</script>
